import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gray-50 dark:bg-slate-900" }
const _hoisted_2 = { class: "max-w-4xl mx-auto px-4 py-6" }
const _hoisted_3 = {
  class: "relative overflow-hidden rounded-2xl mb-8",
  style: {"background":"linear-gradient(135deg, #06B6D4 0%, #0891B2 50%, #0E7490 100%)"}
}
const _hoisted_4 = { class: "relative p-8" }
const _hoisted_5 = { class: "flex items-center gap-4" }
const _hoisted_6 = { class: "text-2xl font-bold text-white" }
const _hoisted_7 = { class: "text-white/90 text-lg font-medium" }
const _hoisted_8 = { class: "mb-8" }
const _hoisted_9 = { class: "bg-white dark:bg-slate-800 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 dark:border-slate-700" }
const _hoisted_10 = { class: "p-6" }
const _hoisted_11 = { class: "flex items-center gap-3 mb-6" }
const _hoisted_12 = { class: "text-xl font-semibold text-slate-900 dark:text-white" }
const _hoisted_13 = { class: "text-slate-600 dark:text-slate-300" }
const _hoisted_14 = { class: "space-y-8" }
const _hoisted_15 = { class: "space-y-6" }
const _hoisted_16 = { class: "text-lg font-semibold text-slate-900 dark:text-white" }
const _hoisted_17 = { class: "grid grid-cols-1 md:grid-cols-2 gap-6" }
const _hoisted_18 = { class: "space-y-2" }
const _hoisted_19 = { class: "block text-sm font-semibold text-slate-700 dark:text-slate-300" }
const _hoisted_20 = { class: "space-y-2" }
const _hoisted_21 = { class: "block text-sm font-semibold text-slate-700 dark:text-slate-300" }
const _hoisted_22 = { class: "space-y-2" }
const _hoisted_23 = { class: "block text-sm font-semibold text-slate-700 dark:text-slate-300" }
const _hoisted_24 = { class: "text-sm text-slate-500 dark:text-slate-400 bg-amber-50 dark:bg-amber-900/20 p-2 rounded-lg border border-amber-200 dark:border-amber-800" }
const _hoisted_25 = { class: "space-y-2" }
const _hoisted_26 = { class: "block text-sm font-semibold text-slate-700 dark:text-slate-300" }
const _hoisted_27 = { class: "md:col-span-2 space-y-2" }
const _hoisted_28 = { class: "block text-sm font-semibold text-slate-700 dark:text-slate-300" }
const _hoisted_29 = ["placeholder"]
const _hoisted_30 = { class: "space-y-4" }
const _hoisted_31 = { class: "flex items-center gap-3" }
const _hoisted_32 = { class: "text-lg font-semibold text-slate-900 dark:text-white" }
const _hoisted_33 = { class: "text-slate-600 dark:text-slate-300" }
const _hoisted_34 = { class: "flex items-center gap-6 p-4 bg-gray-50 dark:bg-slate-800/50 rounded-xl border border-gray-200 dark:border-slate-600" }
const _hoisted_35 = { class: "flex-shrink-0" }
const _hoisted_36 = {
  key: 0,
  class: "relative"
}
const _hoisted_37 = ["src"]
const _hoisted_38 = {
  key: 1,
  class: "w-16 h-16 bg-gradient-to-br from-cyan-100 to-teal-100 dark:from-cyan-900/30 dark:to-teal-900/30 rounded-xl flex items-center justify-center"
}
const _hoisted_39 = { class: "flex-grow" }
const _hoisted_40 = { class: "text-sm font-medium text-slate-900 dark:text-white mb-1" }
const _hoisted_41 = { class: "text-xs text-slate-500 dark:text-slate-400 mb-3" }
const _hoisted_42 = {
  for: "fileInput",
  class: "choose-file-btn inline-flex items-center px-4 py-2 text-white text-sm font-medium rounded-lg transition-all duration-200 cursor-pointer shadow-sm hover:shadow-md"
}
const _hoisted_43 = { class: "flex items-center gap-2" }
const _hoisted_44 = {
  key: 0,
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_45 = {
  key: 1,
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_46 = { class: "text-sm font-medium" }
const _hoisted_47 = { class: "flex items-center gap-4 pt-6 border-t border-gray-200 dark:border-slate-600" }
const _hoisted_48 = ["disabled"]
const _hoisted_49 = {
  key: 0,
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_50 = {
  key: 1,
  class: "w-4 h-4 animate-spin",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SettingsNav = _resolveComponent("SettingsNav")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "absolute inset-0 opacity-10" }, [
          _createElementVNode("div", { class: "absolute top-4 right-4 w-32 h-32 rounded-full bg-white/20" }),
          _createElementVNode("div", { class: "absolute -top-8 -right-8 w-24 h-24 rounded-full bg-white/10" }),
          _createElementVNode("div", { class: "absolute bottom-4 left-4 w-20 h-20 rounded-full bg-white/15" })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "w-16 h-16 rounded-2xl bg-white/20 backdrop-blur-sm flex items-center justify-center shadow-lg" }, [
              _createElementVNode("svg", {
                class: "w-8 h-8 text-white",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                })
              ])
            ], -1)),
            _createElementVNode("div", null, [
              _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.directT('settings.accountSettings.accountSettings')), 1),
              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.directT('settings.accountSettings.managePersonalInfo')), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_SettingsNav)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "w-10 h-10 rounded-xl bg-gradient-to-br from-cyan-100 to-teal-100 dark:from-cyan-900/20 dark:to-teal-900/20 flex items-center justify-center shadow-inner" }, [
              _createElementVNode("svg", {
                class: "w-5 h-5 text-cyan-600 dark:text-cyan-400",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                })
              ])
            ], -1)),
            _createElementVNode("div", null, [
              _createElementVNode("h2", _hoisted_12, _toDisplayString(_ctx.directT('settings.accountSettings.profile')), 1),
              _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.directT('settings.accountSettings.updatePhotoAndDetails')), 1)
            ])
          ]),
          _createElementVNode("form", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("h3", _hoisted_16, _toDisplayString(_ctx.directT('settings.accountSettings.basicInformation')), 1),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.directT('settings.accountSettings.firstName')), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.profileData.first_name) = $event)),
                    class: "w-full px-4 py-3 bg-white dark:bg-slate-900 border border-gray-200 dark:border-slate-600 rounded-xl focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 text-slate-900 dark:text-white transition-all duration-200 shadow-sm placeholder:text-slate-400",
                    placeholder: "Enter your first name"
                  }, null, 512), [
                    [_vModelText, _ctx.profileData.first_name]
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.directT('settings.accountSettings.lastName')), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.profileData.last_name) = $event)),
                    class: "w-full px-4 py-3 bg-white dark:bg-slate-900 border border-gray-200 dark:border-slate-600 rounded-xl focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 text-slate-900 dark:text-white transition-all duration-200 shadow-sm placeholder:text-slate-400",
                    placeholder: "Enter your last name"
                  }, null, 512), [
                    [_vModelText, _ctx.profileData.last_name]
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.directT('settings.accountSettings.emailAddress')), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "email",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.profileData.email) = $event)),
                    disabled: "",
                    class: "w-full px-4 py-3 bg-gray-100 dark:bg-slate-800 border border-gray-200 dark:border-slate-600 rounded-xl text-slate-500 dark:text-slate-400 cursor-not-allowed"
                  }, null, 512), [
                    [_vModelText, _ctx.profileData.email]
                  ]),
                  _createElementVNode("p", _hoisted_24, [
                    _cache[11] || (_cache[11] = _createElementVNode("svg", {
                      class: "w-4 h-4 inline mr-2 text-amber-500",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
                      })
                    ], -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.directT('settings.accountSettings.emailCannotBeChanged')), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.directT('settings.accountSettings.phoneNumber')), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "tel",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.profileData.phone) = $event)),
                    class: "w-full px-4 py-3 bg-white dark:bg-slate-900 border border-gray-200 dark:border-slate-600 rounded-xl focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 text-slate-900 dark:text-white transition-all duration-200 shadow-sm placeholder:text-slate-400",
                    placeholder: "Enter your phone number"
                  }, null, 512), [
                    [_vModelText, _ctx.profileData.phone]
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.directT('settings.accountSettings.location')), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.profileData.location) = $event)),
                    class: "w-full px-4 py-3 bg-white dark:bg-slate-900 border border-gray-200 dark:border-slate-600 rounded-xl focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 text-slate-900 dark:text-white transition-all duration-200 shadow-sm placeholder:text-slate-400",
                    placeholder: _ctx.directT('settings.accountSettings.enterYourLocation')
                  }, null, 8, _hoisted_29), [
                    [_vModelText, _ctx.profileData.location]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "w-8 h-8 rounded-lg bg-gradient-to-br from-purple-100 to-pink-100 dark:from-purple-900/20 dark:to-pink-900/20 flex items-center justify-center" }, [
                  _createElementVNode("svg", {
                    class: "w-4 h-4 text-purple-600 dark:text-purple-400",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                    })
                  ])
                ], -1)),
                _createElementVNode("div", null, [
                  _createElementVNode("h3", _hoisted_32, _toDisplayString(_ctx.directT('settings.accountSettings.profileInfo')), 1),
                  _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.directT('settings.accountSettings.displayedProfile')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  (_ctx.profileData.profile_picture_link)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                        _createElementVNode("img", {
                          src: _ctx.profileData.profile_picture_link,
                          alt: "Profile Picture",
                          class: "w-16 h-16 object-cover rounded-xl border-2 border-white dark:border-slate-700 shadow-sm"
                        }, null, 8, _hoisted_37),
                        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "absolute -bottom-1 -right-1 w-6 h-6 bg-green-500 rounded-full border-2 border-white dark:border-slate-700 flex items-center justify-center" }, [
                          _createElementVNode("svg", {
                            class: "w-3 h-3 text-white",
                            fill: "none",
                            stroke: "currentColor",
                            viewBox: "0 0 24 24"
                          }, [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M5 13l4 4L19 7"
                            })
                          ])
                        ], -1))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_38, _cache[14] || (_cache[14] = [
                        _createElementVNode("svg", {
                          class: "w-8 h-8 text-cyan-600 dark:text-cyan-400",
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                          })
                        ], -1)
                      ])))
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("p", _hoisted_40, _toDisplayString(_ctx.directT('settings.accountSettings.profilePicture')), 1),
                  _createElementVNode("p", _hoisted_41, _toDisplayString(_ctx.directT('settings.accountSettings.fileTypeSize')), 1),
                  _createElementVNode("input", {
                    type: "file",
                    id: "fileInput",
                    class: "hidden",
                    onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleProfilePictureUpload && _ctx.handleProfilePictureUpload(...args))),
                    accept: "image/*"
                  }, null, 32),
                  _createElementVNode("label", _hoisted_42, [
                    _cache[15] || (_cache[15] = _createElementVNode("svg", {
                      class: "w-4 h-4 mr-2",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
                      })
                    ], -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.directT('settings.accountSettings.chooseFile')), 1)
                  ])
                ])
              ]),
              (_ctx.uploadStatus)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["p-3 rounded-lg border", {
                 'bg-emerald-50 dark:bg-emerald-900/20 text-emerald-700 dark:text-emerald-400 border-emerald-200 dark:border-emerald-800': _ctx.uploadStatus === 'success',
                 'bg-red-50 dark:bg-red-900/20 text-red-700 dark:text-red-400 border-red-200 dark:border-red-800': _ctx.uploadStatus === 'error'
               }])
                  }, [
                    _createElementVNode("div", _hoisted_43, [
                      (_ctx.uploadStatus === 'success')
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_44, _cache[16] || (_cache[16] = [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M5 13l4 4L19 7"
                            }, null, -1)
                          ])))
                        : (_openBlock(), _createElementBlock("svg", _hoisted_45, _cache[17] || (_cache[17] = [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M6 18L18 6M6 6l12 12"
                            }, null, -1)
                          ]))),
                      _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.uploadStatusMessage), 1)
                    ])
                  ], 2))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args))),
                class: "px-6 py-3 text-sm font-medium text-slate-700 dark:text-slate-300 bg-gray-100 dark:bg-slate-700 rounded-lg hover:bg-gray-200 dark:hover:bg-slate-600 transition-all duration-200"
              }, _toDisplayString(_ctx.directT('settings.accountSettings.cancel')), 1),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.updateProfile && _ctx.updateProfile(...args))),
                disabled: _ctx.isLoading,
                class: "update-profile-btn px-6 py-3 text-sm font-medium text-white rounded-lg transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2 shadow-sm hover:shadow-md"
              }, [
                (!_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_49, _cache[18] || (_cache[18] = [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M5 13l4 4L19 7"
                      }, null, -1)
                    ])))
                  : (_openBlock(), _createElementBlock("svg", _hoisted_50, _cache[19] || (_cache[19] = [
                      _createElementVNode("circle", {
                        class: "opacity-25",
                        cx: "12",
                        cy: "12",
                        r: "10",
                        stroke: "currentColor",
                        "stroke-width": "4"
                      }, null, -1),
                      _createElementVNode("path", {
                        class: "opacity-75",
                        fill: "currentColor",
                        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      }, null, -1)
                    ]))),
                _createTextVNode(" " + _toDisplayString(_ctx.isLoading ? _ctx.directT('settings.accountSettings.updating') : _ctx.directT('settings.accountSettings.updateProfile')), 1)
              ], 8, _hoisted_48)
            ])
          ])
        ])
      ])
    ])
  ]))
}